import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { GlobalConstants, ImageTypes } from './global-constants';
import { Observable, catchError, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ImageuploadService {
  constructor(private dataService: DataService, private http: HttpClient) { }

  async uploadImage(image: File, type: string = ImageTypes.ou): Promise<any> {
    const formData = new FormData();
    formData.append('file', image);
    let res = await this.dataService.postData('file/' + type, formData, 'POST', true);
    return res;
  }

  uploadImageWithProgress(image: File, type: ImageTypes): Observable<any> {
    const formData = new FormData();
    formData.append('file', image);
    return this.http.post(`${GlobalConstants.apiURL}file/${type}`, formData, {
      reportProgress: true,
      observe: 'events',
    }).pipe(catchError(this.errorMgmt));
  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
